import React, { useEffect, useState } from "react";
import { Image } from "tsi-common-react/src/common/Image";
import { Link } from "tsi-common-react/src/common/Link";
import { format } from "tsi-common-react/src/utils/format";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import styles from "./OrderOffer.module.scss";

interface OrderOfferProps {
    offer_freq: string;
    benefit_value: string;
    desktop_image?: string;
    mobile_image?: string;
    offer_name: string;
}

export const OrderOffer = (props: OrderOfferProps) => {
    const window = getWindow();
    const isMobileSize = window ? window.innerWidth <= 500 : false;
    const [isMobile, setIsMobile] = useState(isMobileSize);
    const cardURL = usePageURL("how_will_i_receive_my_card");

    useEffect(() => {
        const window = getWindow();
        if (!window) {
            return;
        }
        window.addEventListener("resize", isWindowResizing);
        return () => {
            window.removeEventListener("resize", isWindowResizing);
        };
    }, [isWindowResizing]);

    function isWindowResizing() {
        if (isMobileSize) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }
    return (
        <div className={styles.grid}>
            <Image
                className={styles.image}
                alt={props.offer_name}
                src={isMobile ? props.mobile_image : props.desktop_image}
            />
            <div className={styles.offerInfo}>
                {/* TODO(i18n): Translate props.offer_name if it's user-facing content from backend */}
                <h5>{props.offer_name}</h5>
                <span>
                    {/* TODO(i18n): Use interpolation to keep sentence together: t`Qty: ${props.offer_freq}` */}
                    {t`Qty:`}&nbsp; {props.offer_freq}{" "}
                </span>
                <span className={styles.offerValue}>
                    {format.money(props.benefit_value)}
                </span>
                <Link href={cardURL} target="_top">
                    {t`How will I receive my card?`}
                </Link>
            </div>
        </div>
    );
};
